import { render, staticRenderFns } from "./invoice-alert.vue?vue&type=template&id=0673d4fc"
import script from "./invoice-alert.vue?vue&type=script&lang=js"
export * from "./invoice-alert.vue?vue&type=script&lang=js"
import style0 from "./invoice-alert.vue?vue&type=style&index=0&id=0673d4fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports